import {ordersServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = ordersServicesPath + '/organizations/settings/export/arrival-material'

export default class ArrivalMaterialExportService {

    static async getAll() {
        return axios.get(restUrl);
    }

    static async get(id) {
        return axios.get(restUrl + "/" + id);
    }


    static async update(data, id) {
        return await axios.put(restUrl + "/" + id,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async create(supplierId, data) {
        return await axios.post(restUrl + "?supplierId=" + supplierId,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}
